import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/LiveTrainBetweenTwoStations.css';
import { LiveTrainStatusContext } from '../LiveTrainStatus';
import {
  getLtsCardDetailsBetweenFirstAndLastStop,
  getLtsCardDetailsBetweenOriginAndDestinationStop
} from '../utils/ltsCardDetailsUtils';
import CurrentAndNextStationDetails from './CurrentAndNextStationDetails';
import TrainNameNumberDesktop from './TrainNameNumberDesktop';
import { DAY, DAYS } from '../constants/LtsConstants';

export const LiveTrainBetweenTwoStations = ({ customClass }) => {
  const { ltsPageState } = useContext(LiveTrainStatusContext);
  const {
    trainName,
    trainNumber,
    firstStoppingStation,
    lastStoppingStation,
    totalDistance,
    currentStation,
    currentIntermediateStation,
    originStation,
    destinationStation,
    trainStartedFromSource,
    trainReachedDestination
  } = {
    ...ltsPageState
  };
  if (!originStation || !destinationStation) {
    return null;
  } else if (!firstStoppingStation || !lastStoppingStation || !trainStartedFromSource || trainReachedDestination) {
    const {
      originStationName,
      destinationStationName,
      departureTimeOfOriginStation,
      arrivalTimeOfDestinationStation,
      dayDifference
    } = getLtsCardDetailsBetweenOriginAndDestinationStop({
      originStation,
      destinationStation
    });

    const distanceCovered = trainReachedDestination ? '100%' : '0%';
    const remainingDistance = trainReachedDestination ? 0 : totalDistance;

    return (
      <div className={`${customClass} liveTrainBetweenTwoStations`}>
        <div className="appendBottom5 liveTrainBetweenTwoStations__currentTrain">
          <TrainNameNumberDesktop trainName={trainName} trainNumber={trainNumber} />
          <div />
          {currentStation && (
            <div className="liveTrainBetweenTwoStations__progress">
              <div className="makeFlex column">
                <span className="font14 latoBold appendBottom25 blackText">{originStationName}</span>
                <div className="makeFlex hrtlCenter">
                  {' '}
                  <span>{departureTimeOfOriginStation}</span>
                </div>
              </div>
              <div className="makeFlex column">
                <span className="font14 latoBold appendBottom25 blackText textRight">{destinationStationName}</span>
                <span className="textRight">
                  {dayDifference > 0 ? `(+${dayDifference} ${dayDifference === 1 ? DAY : DAYS})` : ''}
                  {arrivalTimeOfDestinationStation}
                </span>
              </div>
              <div className="trainDistanceIndicator" />
              <div className="trainDistanceCovered">
                <div className="distanceCovered" style={{ width: distanceCovered }} />
                <span className="railSeoSprite trainCurrentStatus" style={{ left: distanceCovered }} />
              </div>
            </div>
          )}
          <p className="font14 blackText textCenter">
            Remaining &nbsp;<span className="latoBold">{remainingDistance} kms</span>
          </p>
        </div>
      </div>
    );
  } else {
    // TODO: keep the green indicator line based on the distance covered and distance remaining to be covered
    const {
      departureTimeOfFirstStop,
      arrivalTimeOfLastStop,
      dayDifference,
      isOnTime,
      remainingDistance,
      remainingTime,
      firstStationName,
      lastStationName,
      distanceTravelled
    } = getLtsCardDetailsBetweenFirstAndLastStop({
      firstStoppingStation,
      lastStoppingStation,
      totalDistance,
      currentStation,
      currentIntermediateStation
    });

    const distanceCovered = `${Math.ceil((distanceTravelled / totalDistance) * 100)}%`;
    const formattedRemainingTime = `${remainingTime.substring(0, 2)}h ${remainingTime.substring(3, 5)}m`;
    return (
      <div className={`${customClass} liveTrainBetweenTwoStations`}>
        <div className="appendBottom5 liveTrainBetweenTwoStations__currentTrain">
          <TrainNameNumberDesktop trainName={trainName} trainNumber={trainNumber} />
          <div />
          {currentStation && (
            <div className="liveTrainBetweenTwoStations__progress">
              <div className="makeFlex column">
                <span className="font14 latoBold appendBottom25 blackText">{firstStationName}</span>
                <div className="makeFlex hrtlCenter">
                  {' '}
                  <span>{departureTimeOfFirstStop}</span>
                  <span className={isOnTime ? 'onTimeTag' : 'notOnTimeTag'}>{isOnTime ? 'On-time' : 'Late'}</span>
                </div>
              </div>
              <div className="makeFlex column">
                <span className="font14 latoBold appendBottom25 blackText textRight">{lastStationName}</span>
                <span className="textRight">
                  {dayDifference > 0 ? `(+${dayDifference} ${dayDifference === 1 ? 'Day' : 'Days'})` : ''}
                  {arrivalTimeOfLastStop}
                </span>
              </div>
              <div className="trainDistanceIndicator" />
              <div className="trainDistanceCovered">
                <div className="distanceCovered" style={{ width: distanceCovered }} />
                <span className="railSeoSprite trainCurrentStatus" style={{ left: distanceCovered }} />
              </div>
            </div>
          )}
          {currentStation && (
            <p className="font14 blackText textCenter">
              Remaining &nbsp;<span className="latoBold">{remainingDistance}</span> in{' '}
              <span className="latoBold">{formattedRemainingTime}</span>
            </p>
          )}
        </div>
        <div className="liveTrainBetweenTwoStations__currentTrain">
          <CurrentAndNextStationDetails />
        </div>
      </div>
    );
  }
};

LiveTrainBetweenTwoStations.propTypes = {
  customClass: PropTypes.string
};

export default LiveTrainBetweenTwoStations;
